// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { SimManagementAdminAreaId } from './SimManagementAdminAreaId'
import { SimManagementAdminAreaNavigation } from './SimManagementAdminAreaNavigation'
import { SimManagementAdminAreaRoutes } from './SimManagementAdminAreaRoutes'

const LazySimManagementAdminComponent = lazy(
  () => import('./SimManagementAdminArea'),
)

const SimManagementAdminComponent = () => (
  <SuspenseLoadingWrapper>
    <LazySimManagementAdminComponent />
  </SuspenseLoadingWrapper>
)

export const SimManagementAdminArea = {
  id: SimManagementAdminAreaId,
  requiredRight: BoumRight.AREA_ADMIN_PANEL_VEHICLE_DEVICE_MANAGEMENT,
  NavigationComponent: SimManagementAdminAreaNavigation,
  route: {
    path: SimManagementAdminAreaRoutes.route,
    component: SimManagementAdminComponent,
  },
}
